import { tsValidateBoolean, tsValidateString, tsValidateUniqueId } from '@nu-art/ts-common';
import { knowledgeManagerDBGroup } from '@app/hcs-shared';
const Validator_MandatoryPropsEncounterSimulation = {
    eventId: tsValidateUniqueId,
    encounterId: tsValidateUniqueId,
    facilityId: tsValidateUniqueId,
    environmentId: tsValidateUniqueId,
    title: tsValidateString(),
    demoSimulation: tsValidateBoolean(false),
    keep: tsValidateBoolean(false),
};
const Validator_GeneratedProps = {};
export const DBDef_EncounterSimulation = {
    modifiablePropsValidator: Validator_MandatoryPropsEncounterSimulation,
    generatedPropsValidator: Validator_GeneratedProps,
    versions: ['1.0.3', '1.0.2', '1.0.1', '1.0.0'],
    dbKey: 'encounter-simulations',
    generatedProps: [],
    frontend: {
        group: knowledgeManagerDBGroup,
        name: 'encounter-simulations'
    },
    backend: {
        name: 'encounter-simulations'
    },
    entityName: 'EncounterSimulations',
    dependencies: {
        'eventId': {
            dbKey: 'encounter-events',
            fieldType: 'string',
        },
        'facilityId': {
            dbKey: 'facility',
            fieldType: 'string',
        },
        'environmentId': {
            dbKey: 'environments',
            fieldType: 'string',
        },
    }
};
//# sourceMappingURL=db-def.js.map